<template>
  <div>
    <!-- <el-tabs
      ref="navTabs"
      tab-position="left"
      style="width: 266px"
      class="title-tab"
      v-model="courseSort"
      @mouseover.native="hoverTab"
      @tab-click="tabClick"
    >
      <el-tab-pane
        v-for="(item, index) of specialtys"
        :key="index"
        :name="item.id"
      >
        <div slot="label" class="tab-lable">
          {{ item.specialtyName }}
          <i
            class="el-icon-arrow-right"
            v-if="item.cmsSpecialtyList.length"
          ></i>
        </div>
        <ul v-for="(key, i) of item.cmsSpecialtyList" :key="i">
          <li
            :class="childSort === key.id ? 'active' : ''"
            @click="getLastSort(key)"
          >
            {{ key.specialtyName }}
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs> -->

    <div class="se-tool">
      <div class="se-p-t-15 se-p-b-15 se-flex se-flex">
        <div class="ft-14-000 min-w" style="white-space: nowrap">分类:</div>
        <!-- <div class="se-m-r-50 ft-14-000 min-w">全部</div> -->
        <div class="se-class-1">
          <div
            :class="[
              'se-m-l-60 ft-14-333 min-w-68 se-m-b-20',
              supIndex == index ? 'active' : '',
            ]"
            v-for="(item, index) in courseCateList"
            :key="index"
            @click="handleChangeSuper(index)"
          >
            {{ item.specialtyName }}
          </div>
        </div>
      </div>
      <template v-if="supIndex > 0 && subCourseCateList.length > 0">
        <div class="se-p-t-15 se-p-b-15 se-flex border-bt">
          <div class="se-m-r-60 ft-14-000 min-w" style="white-space: nowrap">
            子分类:
          </div>
          <!-- <div class="se-m-r-50 ft-14-000 min-w">全部</div> -->
          <div class="se-class-1">
            <div
              :class="[
                'se-m-r-60 ft-14-333 min-w-68',
                subIndex == index ? 'active' : '',
              ]"
              v-for="(item, index) in subCourseCateList"
              :key="index"
              @click="handleChangeSub(index)"
            >
              {{ item.specialtyName }}
            </div>
          </div>
        </div>
      </template>

      <div class="se-p-t-15 se-p-b-15 se-flex">
        <div class="se-m-r-60 ft-14-000 min-w" style="white-space: nowrap">
          专栏:
        </div>
        <div
          :class="[
            'se-m-r-60 ft-14-000 min-w-68',
            thirdIndex == 0 ? 'active' : '',
          ]"
          @click="handleChangeSepcialty(0)"
        >
          全部
        </div>
        <div
          :class="[
            'se-m-r-60 ft-14-333 min-w-68',
            thirdIndex == 1 ? 'active' : '',
          ]"
          @click="handleChangeSepcialty(1)"
        >
          新推课程
        </div>
        <div
          :class="[
            'se-m-r-60 ft-14-333 min-w-68',
            thirdIndex == 2 ? 'active' : '',
          ]"
          @click="handleChangeSepcialty(2)"
        >
          精品课程
        </div>
      </div>
    </div>
    <div class="se-sort se-flex jcsb aic">
      <div class="se-flex">
        <div
          class="se-m-r-30 pointer"
          :style="{ color: active === 0 ? '#f41539' : '' }"
          @click="getSort(0)"
        >
          综合排序
        </div>
        <div
          class="se-flex aic se-m-r-30 pointer"
          @click="getSort(1, 0, order ? 0 : 1)"
        >
          <div
            class="se-m-r-5"
            :style="{ color: active === 1 ? '#f41539' : '' }"
          >
            好评率
          </div>
          <div class="arr">
            <div
              class="arrUp"
              :style="{
                borderBottomColor:
                  sort === 0 && order === 0 ? '#f41539' : '#C8C8C8',
              }"
            ></div>
            <div
              class="arrDown"
              :style="{
                borderTopColor:
                  sort === 0 && order === 1 ? '#f41539' : '#C8C8C8',
              }"
            ></div>
          </div>
        </div>
        <div
          class="se-flex aic se-m-r-30 pointer"
          @click="getSort(2, 1, order ? 0 : 1)"
        >
          <div
            class="se-m-r-5"
            :style="{ color: active === 2 ? '#f41539' : '' }"
          >
            学习次数
          </div>
          <div class="arr">
            <div
              class="arrUp"
              :style="{
                borderBottomColor:
                  sort === 1 && order === 0 ? '#f41539' : '#C8C8C8',
              }"
            ></div>
            <div
              class="arrDown"
              :style="{
                borderTopColor:
                  sort === 1 && order === 1 ? '#f41539' : '#C8C8C8',
              }"
            ></div>
          </div>
        </div>
        <div
          class="se-flex aic se-m-r-30 pointer"
          @click="getSort(3, 2, order ? 0 : 1)"
        >
          <div
            class="se-m-r-5"
            :style="{ color: active === 3 ? '#f41539' : '' }"
          >
            发布时间
          </div>
          <div class="arr">
            <div
              class="arrUp"
              :style="{
                borderBottomColor:
                  sort === 2 && order === 0 ? '#f41539' : '#C8C8C8',
              }"
            ></div>
            <div
              class="arrDown"
              :style="{
                borderTopColor:
                  sort === 2 && order === 1 ? '#f41539' : '#C8C8C8',
              }"
            ></div>
          </div>
        </div>
      </div>
      <!-- <div class="se-flex aic">
        <div class="se-m-r-15">起止时间</div>
        <el-date-picker
          v-model="dateRange"
          @change="handleDateChange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div> -->
    </div>
    <div class="se-list">
      <div
        class="se-item pos-r se-m-b-20"
        v-for="(item, index) in courseList"
        :key="index"
        @click="goInfo(item)"
      >
        <course-item :item="item" :from="from"></course-item>
        <img
          v-if="item.isExcellent"
          src="../../assets/icons/youxiu.png"
          class="se-img-tj"
          style="width: 63px; height: 28px"
        />
        <img
          v-if="(item.isHighQuality && item.isExcellent) || item.isHighQuality"
          src="../../assets/icons/jingpin.png"
          class="se-img-tj"
          style="width: 63px; height: 28px"
        />
      </div>
    </div>
    <div class="se-flex-h-c">
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import courseItem from "../components/courseItem.vue";

export default {
  components: {
    courseItem,
  },

  data() {
    return {
      from: "home",
      value: "",
      currentPage: 1,
      dateRange: [], //日期
      endDate: "",
      beginDate: "",
      prentSepcialty: "", //1级别分类
      sepcialty: "", //二级分类
      isExcellent: "",
      isHighQuality: "",
      courseList: [],
      courseCateList: [],
      subCourseCateList: [],
      supIndex: 0,
      subIndex: 0,
      thirdIndex: 0,
      pageNum: 1,
      pageSize: 12,
      total: 0,
      timeSort: 0,
      order: undefined,
      sort: undefined,
      active: undefined,
    };
  },

  watch: {
    "$route.query.t"(value) {
      this.handleRoute();
    },
  },
  created() {
    this.prentSepcialty = this.$route.query.prentSepcialty || "";
    this.sepcialty = this.$route.query.sepcialty || this.$route.query.son || "";
    this.isExcellent = this.$route.query.isExcellent || "";
    this.isHighQuality = this.$route.query.isHighQuality || "";
    if (this.$route.query.key) {
      this[this.$route.query.key] = this.$route.query.value;
    }
    this.handleChangeSepcialty(this.$route.query.value);
    this.getCourseCateList();
    this.thirdIndex = Number(this.$route.query.value);
  },

  methods: {
    handleRoute() {
      const index = this.courseCateList.findIndex(
        (s) => s.id === this.$route.query.active
      );
      this.handleChangeSuper(index > -1 ? index : 0);
    },
    getSort(active, sort, order) {
      this.active = active;
      this.sort = sort;
      this.order = order;
      this.getCourseList();
    },
    // 分页回调
    currentChange(val) {
      this.pageNum = val;
      this.getCourseList();
    },

    handleDateChange(v) {
      // console.log(v, "日期变化");
      this.beginDate =
        this.dateRange && this.dateRange.length > 0 ? this.dateRange[0] : "";
      this.endDate =
        this.dateRange && this.dateRange.length > 0 ? this.dateRange[0] : "";
      this.pageNum = 1;
      this.getCourseList();
    },

    // 去课程详情
    goInfo(item) {
      // this.$router.push({ name: 'courseInfo', query: { type: 'course' } })
      // console.log(item, "当前课程");
      this.$router.push({
        path: "/course-info/index",
        query: {
          type: "course",
          courseId: item.courseId,
          teacherId: item.teacherId,
        },
      });
      // this.$router.push({})
    },

    handleChangeSuper(index) {
      this.supIndex = index; //父级索引
      this.subIndex = 0; //子级索引

      this.subCourseCateList =
        this.courseCateList[this.supIndex]["cmsSpecialtyList"]; //子级数据
      if (
        this.subCourseCateList.length !== 0 &&
        this.subCourseCateList[0].specialtyName !== "全部"
      )
        this.subCourseCateList.splice(0, 0, {
          specialtyName: "全部",
          id: "",
        });
      this.prentSepcialty = this.courseCateList[this.supIndex]["id"]; //父级id
      if (this.subCourseCateList && this.subCourseCateList.length > 0) {
        this.sepcialty = this.subCourseCateList[this.subIndex]["id"]; //子级id
      } else {
        this.sepcialty = undefined;
      }
      this.pageNum = 1;
      if (this.$route.query.son) {
        const index = this.subCourseCateList.findIndex(
          (s) => s.id === this.$route.query.son
        );
        this.subIndex = index > -1 ? index : 0;
      }
      this.getCourseList();
    },

    handleChangeSub(index) {
      this.subIndex = index;
      this.sepcialty = this.subCourseCateList[this.subIndex]["id"]; //子级id
      this.pageNum = 1;
      this.getCourseList();
    },

    //第三级
    handleChangeSepcialty(index) {
      this.thirdIndex = index;
      // console.log(this.thirdIndex, "thirdIndex");
      this.pageNum = 1;
      if (index == 0) {
        this.isExcellent = "";
        this.isHighQuality = "";
      } else if (index == 1) {
        this.isExcellent = 1;
        this.isHighQuality = "";
      } else if (index == 2) {
        this.isExcellent = "";
        this.isHighQuality = 1;
      }
      this.getCourseList();
    },

    //获取课程分类
    getCourseCateList() {
      let data = {
        prentSepcialty: this.prentSepcialty, //父级id
        sepcialty: this.sepcialty, //子级id
        isExcellent: this.isExcellent, //优秀
        isHighQuality: this.isHighQuality, //精品
      };
      this.$http.get("server/portal/home/specialty").then((res) => {
        if (res.status == 200) {
          this.courseCateList = res.data;
          this.courseCateList = this.courseCateList.filter(
            (v) => v.cmsSpecialtyList.length !== 0
          );
          this.courseCateList.splice(0, 0, {
            specialtyName: "全部",
            id: "",
            cmsSpecialtyList: [],
          });
          this.sepcialty = this.courseCateList[0]["id"]; //初始化专业id
          this.supIndex = this.courseCateList.findIndex((item, index) => {
            return item.id == this.prentSepcialty;
          });
          this.subCourseCateList =
            this.courseCateList[this.supIndex]["cmsSpecialtyList"];
          this.subCourseCateList.unshift({
            specialtyName: "全部",
            id: "",
          });
          // console.log(this.subCourseCateList, "subCourseCateList");
          // this.getCourseList(); //课程列表
          this.handleRoute();
        }
      });
    },

    //获取课程列表
    getCourseList() {
      let data = {
        isExcellent: this.isExcellent, //优秀课程1
        isHighQuality: this.isHighQuality, //精品课程1
        prentSepcialty: this.prentSepcialty, //父级专业id
        sepcialty: this.sepcialty || this.$route.query.son, //子级
        order: this.order, //排序
        sort: this.sort,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$http.get("server/portal/home/listCourse", data).then((res) => {
        this.courseList = res.rows;
        this.total = res.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.se-tool {
  background-color: #fff;
  padding: 0 20px;
  border-radius: 10px;
}

.border-bt {
  border-top: 1px solid rgba(233, 233, 233, 0.46);
  border-bottom: 1px solid rgba(233, 233, 233, 0.46);
}

.min-w {
  min-width: 44px;
}

.min-w-68 {
  min-width: 68px;
  cursor: pointer;
}

.active {
  // box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.09);
  color: #f41539;
  // background-color: #ffffff;
}

.se-sort {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 10px;
  padding: 10px;
}

/deep/ .el-date-editor .el-range-separator {
  padding: 0;
}

.se-list {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
  .se-item {
    margin-right: 20px;
    width: calc((100% - 60px) / 4);
    background-color: #fff;
    border-radius: 10px;
    &:nth-child(4n) {
      margin-right: 0;
    }
    > div {
      height: 100%;
    }
  }
}

.arr {
  margin-left: 2px;
  width: 10px;
  .arrUp {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom-color: #707175;
    cursor: pointer;
  }
  .arrDown {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: #707175;
    margin-top: 3px;
    cursor: pointer;
  }
}

.pointer {
  cursor: pointer;
}

.se-img-tj {
  position: absolute;
  right: -1px;
  top: -1px;
}

.se-class-1 {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
</style>
